<template>
  <div role="tablist">
    <div v-for="(item, index) in projectTypeData" :key="index">
      <a
        class="collapse-button"
        v-b-toggle="`accordion-${index}`"
        @click="onChangeImgUr(item.picUrl, 'img')"
      >
        <img :src="getImgUrl(item.picUrl)" alt />
        <p class="maxLength-text-1">{{ item.name }}</p>
        <i class="icon-change"></i>
      </a>
      <b-collapse
        :id="`accordion-${index}`"
        visible
        accordion="my-accordion"
        role="tabpanel"
      >
        <b-card-body>
          <b-card-text class="maxLength-text-3">{{ item.intro }}</b-card-text>
          <a @click="onChangeImgUr(item.id, 'details')">
            查看详情
            <img src="@/assets/img/home/arrow-black.png" alt />
          </a>
        </b-card-body>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import publicChange from "@/assets/js/index.js";
export default {
  data() {
    return {
      text: `
         平台汇聚了财经领域的大量专业人才，并且通过平台强大的人才画像功
能和可靠的能力/技能认证功能已经进行了有效的识别和区分……
        `
    };
  },
  props: {
    projectTypeData: {
      type: Array
    },
    categoriesImgUr: {
      type: String
    },
    onChangeImgUr: {
      type: Function
    }
  },
  methods: {
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    onDesc(text) {
      return publicChange.disposeHtml(text);
    }
  }
};
</script>
